import React from "react";
import { UserDetailSection } from "../components/UserDetailSection";
import { LinkedArtistUserPanel } from "components/linkedArtists/LinkedArtistUser";
import { getExternalPermissions, Section } from "UserAdmin/components/permissions/permissionsectioncreator";
import { PermissionGroup } from "UserAdmin/components/permissions/PermissionGroup";

interface Props {
  clientConfig: server.dto.ClientConfiguration
  userToClient: server.dto.UserForExternalAdmin
  onNameChanged: (firstName: string, lastName: string) => void
}

interface UserForExternalState {
  permissions: server.dto.ExternalEnvironmentPermissions;
}

export const UserForExternalDetailSection = (props: Props) => {
  const [state, setState] = React.useState<UserForExternalState>({
    permissions: props.userToClient.areaPermissions,
  });

  const onValueChanged = (key: string, value: any) => {
    if (key.startsWith("permissions")) {
      setState(prevState => ({
        ...prevState,
        permissions: value
      }));
    }
  }

  const sections = getExternalPermissions(props.clientConfig) as Array<Section<server.dto.InternalEnvironmentPermissions | server.dto.ExternalEnvironmentPermissions>>

  return <UserDetailSection
    userToClient={props.userToClient}
    environment="external"
    title={RESX.UserType.ExternalUser}
    updateFunc={window.CoreApi.UserForExternalAdmin.Update}
    onValueChanged={onValueChanged}
    onNameChanged={props.onNameChanged}
    additionalSections={[{
      key: "permissions",
      type: "regular",
      title: RESX.SoUser.Permissions,
      supportArticleId: serverReference.supportArticleIds.internalUserPermissions,
      fields: sections.filter(section => section.isVisible).map(section => ({
        key: `permissions-${section.label}`,
        label: section.label,
        hideLabel: true,
        render: () => <PermissionGroup
          readonly
          userToClientId={props.userToClient.userToClientId}
          userId={props.userToClient.user.userId}
          permissions={state.permissions}
          permissionGroup={section}
          onChange={() => { }}
        />,
        inPageEdit: {
          render: ({ value, onChange }) => <div className="main-section-template-fields-padding">
            <PermissionGroup
              userToClientId={props.userToClient.userToClientId}
              userId={props.userToClient.user.userId}
              permissions={value}
              permissionGroup={getExternalPermissions(props.clientConfig).find(s => s.label === section.label) as Section<server.dto.InternalEnvironmentPermissions | server.dto.ExternalEnvironmentPermissions>}
              onChange={onChange}
            />
          </div>,
          fullWidth: true,
          type: "confirmOrCancelButton",
          initialValue: state.permissions,
          submitChange: (permissions: server.dto.ExternalEnvironmentPermissions) => window.CoreApi.UserForExternalAdmin.UpdatePermissions({
            userToClientId: props.userToClient.userToClientId,
            permissions,
          })
        }
      }))
    }, {
      key: "artists",
      type: "custom",
      render: () => <LinkedArtistUserPanel
        key="artists"
        environment="external"
        userToClientId={props.userToClient.userToClientId}
      />
    }]}
  />
}